import { Alert, AlertTitle, CircularProgress } from '@mui/material';
import { Box } from '@mui/system';
import React from 'react';
import ErrorView from '../errors/ErrorView';

const DialogContentComponent = ({ loading, error, handleClose, title, message, severity = 'success' }) => {
    if (loading) {
        return (
            <Box display="flex" justifyContent="center">
                <CircularProgress />
            </Box>
        );
    }

    if (error) {
        return (
            <ErrorView
                error={error}
                onClose={handleClose}
            />
        );
    }

    if (title && message) {
        return (
            <Alert variant="filled" severity={severity} onClose={handleClose}>
                <AlertTitle>{title}</AlertTitle>
                {message}
            </Alert>
        );
    }

    return null;
};

export default DialogContentComponent;